import { colors } from '@lmc/common/constants'
import { chain, filter } from 'lodash'
import { Component, type CSSProperties } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import { mixpanel } from '../../../common/services/analytics'
import { openDialog } from '../../../common/utils'
import { ScrollLock } from '../../../LEGACY/elemental'
import Operations from '../../../operations'
import { Step, StepList } from '../../generic'
import Modal from '..'
import { Complete, MedTimes, OnboardingStart, Permissions } from './steps'

interface OnboardEmarModalProps {
  close: () => void
  emarRoundTimings: any[]
  fields: any
  isOpen: boolean
  openNewRoundTimingModal: () => void
  deleteRoundTiming: (itemId: string) => void
  carers: any[]
  updateCarer: (params: { itemId: string; permission: string }) => void
  residents: any[]
  home: string
  onFinishOnboarding: (params: { itemId: string }) => void
  testId?: string
}

const MODAL_ID = 'onboardingEmar'

class OnboardEmarModal extends Component<OnboardEmarModalProps> {
  render() {
    const {
      close,
      emarRoundTimings,
      fields,
      isOpen,
      openNewRoundTimingModal,
      deleteRoundTiming,
      carers,
      updateCarer,
      residents,
      home,
      onFinishOnboarding,
      testId,
      ...formProps
    } = this.props

    if (!isOpen) return null

    return (
      <div
        style={styles.container as CSSProperties}
        data-testid={
          testId ? `${testId}-onboard-emar-modal` : 'onboard-emar-modal'
        }
      >
        <StepList
          closeLabel="Cancel"
          onClose={close}
          stepLabels={stepLabels}
          useAntdSteps
        >
          <Step
            formId={MODAL_ID}
            component={OnboardingStart}
            home={home}
            fields={fields}
            testId={testId}
            {...formProps}
          />
          <Step
            formId={MODAL_ID}
            component={MedTimes}
            fields={fields}
            home={home}
            emarRoundTimings={emarRoundTimings}
            openNewRoundTimingModal={openNewRoundTimingModal}
            deleteRoundTiming={deleteRoundTiming}
            testId={testId}
            {...formProps}
          />
          <Step
            formId={MODAL_ID}
            component={Permissions}
            fields={fields}
            carers={carers}
            updateCarer={updateCarer}
            onFinishOnboarding={onFinishOnboarding}
            home={home}
            testId={testId}
            {...formProps}
          />
          <Step
            component={Complete}
            fields={fields}
            formId={MODAL_ID}
            residents={residents}
            onClose={close}
            testId={testId}
            {...formProps}
          />
        </StepList>
        <ScrollLock />
      </div>
    )
  }
}

const stepLabels = ['Start', 'Times', 'Permissions', 'Complete']

const styles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    zIndex: 100,
    background: colors.white
  }
}

// @ts-ignore
const mapStateToProps = (state, props) => {
  return {
    home: state.global.home.id,
    emarRoundTimings: chain(state.data['emar-round-timings'])
      .filter({ deleted: false })
      .orderBy('time')
      .value(),
    carers: state.data.carers,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative,
    residents: filter(state.data.residents, { status: 'active' })
  }
}

const mapDispatchToProps = (dispatch: (arg0: any) => void) => ({
  openNewRoundTimingModal: () => {
    dispatch(Actions.openModal({ modalId: 'addEmarRoundTimingModal' }))
    dispatch(Actions.addForm({ formId: 'addEmarRoundTimingModal' }))
  },
  validateFormFields: (data: any) =>
    dispatch(Operations.validateFormFields({ ...data, formId: MODAL_ID })),
  mixpanel,
  deleteRoundTiming: (itemId: string) => {
    openDialog({
      title: 'Are you sure?',
      type: 'warning',
      text: "This action can't be undone. This medication round time will remain for any existing medications, but you won't be able to choose it for future medications",
      btnLabel: 'Remove',
      onConfirm: () => {
        dispatch(
          Operations.updateListItem({
            listId: 'emar-round-timings',
            successMsg: 'Removed a round timing',
            itemId,
            json: { deleted: true }
          })
        )
      }
    })
  },
  // @ts-ignore
  updateCarer: ({ itemId, permission }) =>
    dispatch(
      Operations.updateListItem({
        listId: 'carers',
        itemId,
        json: { medicationPermission: permission }
      })
    ),
  // @ts-ignore
  onFinishOnboarding: ({ itemId }) =>
    dispatch(
      Operations.saveHomeDetails({
        features: {
          emarOnboarded: {
            granted: true,
            enabled: true
          }
        },
        id: itemId
      })
    )
})

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardEmarModal)
export default Modal(wrappedModal, MODAL_ID)
